export const paymentForm = document.forms.payment
export const rangeInputElement = paymentForm?.elements.period
export const monthsElement = paymentForm?.elements.months
export const perMonthElement = paymentForm?.elements['per-month']
export const rangeTotal = paymentForm?.elements['by-parts-total']
export const bpEmailInput = paymentForm?.elements['bp-email']
export const nameInput = paymentForm?.elements['name']
export const bpNameInput = paymentForm?.elements['bp-name']
export const bpTelegramInput = paymentForm?.elements['bp-telegram']
export const fpEmailInput = paymentForm?.elements['fp-email']
export const fpNameInput = paymentForm?.elements['fp-name']
export const fpTelegramInput = paymentForm?.elements['fp-telegram']
export const promocodeInput = paymentForm?.elements.promocode
export const goodIdInput = paymentForm?.elements.good_id
export const resultMonthsElement = document.querySelector("#months");
export const resultPerMonthElement = document.querySelector("#per-month");
export const resultPerMonthOldElement = document.querySelector("#per-month-old");
export const rangeTrack = document.querySelector(".parts-calculator__range-track");
export const providerChoice = document.querySelector('#provider-choice')
export const paymentTypeStep = document.querySelector('#payment-type-step')
export const promocodeButtons = document.querySelectorAll('.user-contact-data__promocode-button')
export const resultByPartsTotal = document.querySelector('.payment-form__result-total ._by-parts .payment-form__result-total-current')
export const resultFullPriceTotal = document.querySelector('.payment-form__result-total ._full-price .payment-form__result-total-current')
export const resultByPartsTotalOld = document.querySelector('.payment-form__result-total ._by-parts .payment-form__result-total-old')
export const resultFullPriceTotalOld = document.querySelector('.payment-form__result-total ._full-price .payment-form__result-total-old')
export const resultPromocodeText = document.querySelector('.payment-form__result-promocode')
